export default "__VITE_ASSET__5mye1W_I__"